import { HeadingPhrases } from './HeadingPhrases'
import { useTranslation } from 'react-i18next'
import { Icon } from '@/components/ui/icon'

const PART_KEYS = ['situation', 'applicability', 'consequence', 'action', 'result', 'limit'] as const

export function PageAnatomy() {
  const { t } = useTranslation()
  return (
    <section id="how-it-works" aria-labelledby="anatomy-title" className="lp-section lp-anatomy">
      <div className="lp-container lp-anatomy-layout">
        <div className="lp-section-intro">
          <p className="lp-eyebrow">{t('landing:hero.chooser.eyebrow')}</p>
          <h2 id="anatomy-title"><HeadingPhrases text={t('landing:how_it_works.title')} /></h2>
          <p>{t('landing:how_it_works.subtitle')}</p>
          <a className="lp-text-link" href={t('landing:how_it_works.example_href')}>
            {t('landing:how_it_works.example_cta')}<Icon name="nav.arrowRight" size="sm" aria-hidden />
          </a>
        </div>
        <div className="lp-answer-paper">
          <div className="lp-answer-paper-heading">AI Commerce Ready <span>{t('landing:hero.chooser.items.selling.area')}</span></div>
          <h3>{t('landing:hero.chooser.items.selling.question')}</h3>
          <ol>
            {PART_KEYS.map((key, index) => (
              <li key={key}>
                <span aria-hidden>{String(index + 1).padStart(2, '0')}</span>
                <div>
                  <h4>{t(`landing:how_it_works.steps.${key}.title`)}</h4>
                  <p>{t(`landing:how_it_works.steps.${key}.description`)}</p>
                  <blockquote>{t(`landing:how_it_works.steps.${key}.sample`)}</blockquote>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
